import React from "react";

const Subtext = ({ children }) => {
  return <p className="text-sm text-gray-500">{children}</p>;
};

export default Subtext;
